import { CollectionResponse, NftResponse } from "baaanggg"

type Props = {
    nft: NftResponse,
    collection: CollectionResponse
}

export function DetailTab({ nft, collection }: Props) {
    return <div
        className="rounded-t-2lg rounded-b-2lg rounded-tl-none border border-jacarta-100 bg-white p-6 dark:border-gray-400 dark:bg-gray-900 md:p-10">
        <div className="mb-2 flex items-center">
            <span className="mr-2 min-w-[9rem] dark:text-jacarta-300">NFT Address:</span>
            <span className="text-white">{collection.nftContract}</span>
        </div>
        <div className="mb-2 flex items-center">
            <span className="mr-2 min-w-[9rem] dark:text-jacarta-300">Collection Address:</span>
            <span className="text-white">{collection.collectionContract}</span>
        </div>
        <div className="mb-2 flex items-center">
            <span className="mr-2 min-w-[9rem] dark:text-jacarta-300">Token ID:</span>
            <span className="cursor-pointer select-none text-jacarta-700 dark:text-white">{nft.tokenId}</span>
        </div>
        <div className="mb-2 flex items-center">
            <span className="mr-2 min-w-[9rem] dark:text-jacarta-300">Token Standard:</span>
            <span className="text-jacarta-700 dark:text-white">CW-721</span>
        </div>
    </div >
}